import { render, staticRenderFns } from "./RoomAssignmentOccupant.vue?vue&type=template&id=3f43185d&scoped=true&"
import script from "./RoomAssignmentOccupant.vue?vue&type=script&lang=js&"
export * from "./RoomAssignmentOccupant.vue?vue&type=script&lang=js&"
import style0 from "./RoomAssignmentOccupant.vue?vue&type=style&index=0&id=3f43185d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43185d",
  null
  
)

export default component.exports